// NodeDetails.jsx

import React from 'react';

// CSS
import './NodeDetails.css';

// Components
import NodeForm from 'node/form/NodeForm';

/**
 * NodeDetails
 *
 * Editable/read-only NodeForm for Appdeck records.
 *
 * @param {object} node - Active node record.
 * @param {function} [onCoverSaved]
 * @param {function} [onLocationSaved]
 * @param {function} [onSubtitleSaved]
 * @param {function} [onTagsSaved]
 * @param {function} [onNodeChange]
 * @param {string[]} [excludedFieldTypes]
 * @param {boolean} [readOnly=false]
 * @param {boolean} [autoFocusRichText=false] - Autofocus the first richtext field.
 * @param {string|number} [autoFocusKey] - Refocus token for the autofocused richtext field.
 *
 * @returns {ReactNode}
 */
const NodeDetails = React.memo(({
  node,
  onCoverSaved,
  onLocationSaved,
  onSubtitleSaved,
  onTagsSaved,
  onNodeChange,
  excludedFieldTypes,
  readOnly = false,
  autoFocusRichText = false,
  autoFocusKey = '',
}) => {
  const canSave = !readOnly;

  return (
    <div className="node-details-container">
      <NodeForm
        node={node}
        readOnly={readOnly}
        onChange={canSave ? onNodeChange : undefined}
        onCoverSaved={canSave ? onCoverSaved : undefined}
        onLocationSaved={canSave ? onLocationSaved : undefined}
        onSubtitleSaved={canSave ? onSubtitleSaved : undefined}
        onTagsSaved={canSave ? onTagsSaved : undefined}
        excludedFieldTypes={excludedFieldTypes}
        autoFocusRichText={canSave && autoFocusRichText}
        autoFocusKey={autoFocusKey}
      />
    </div>
  );
});

// Dev Tools
NodeDetails.displayName = 'NodeDetails';

export default NodeDetails;
